<template>
    <div>
        <strong>Pursuant to and for the purposes of Articles 1341 and 1342 of the Italian Civil Code</strong>, the User expressly declares to have
        read, understood and accepted the following clauses:

        <p>Art. 1, Definitions, letter l), “Fleequid”, legal entity and applicable tax regulations;</p>
        <p>Art. 2.3 Commissions payable by both the Seller and the Buyer;</p>
        <p>Art. 2.4 Auction procedures and determination of the award price;</p>
        <p>Art. 2.5 Resale process;</p>
        <p>
            Art. 3 Approval of any general conditions proposed by users, unilateral amendment of the General Conditions by Fleequid and hierarchy of
            contractual documents;
        </p>
        <p>Art. 4.5 Limitations on the use of the Marketplace;</p>
        <p>Art. 4.6 Measures adopted by Fleequid in case of breach of the rules of use;</p>
        <p>Art. 4.7 Termination;</p>
        <p>Art. 4.8 Penalty;</p>
        <p>Art. 4.10 Disclaimer of liability for the functioning of the Marketplace;</p>
        <p>Art. 4.11 Deletion of the User profile and exercise of the right of withdrawal;</p>
        <p>
            Art. 6 relating to: express termination clause, exclusive selling mandate, conditions and duration of such exclusivity, possibility of
            subsequent award, sales limitations, right to cancel or terminate the sale in case of delay or non-payment by the Buyer, Seller’s waiver
            of claims or objections, indemnity, technical dossier, penalties charged to the Seller;
        </p>
        <p>
            Art. 7 Invitation to treat (invitatio ad offerendum), duration of the irrevocable purchase offer, specific auction conditions, reserve
            price;
        </p>
        <p>Art. 8.4 Handling of the security deposit;</p>
        <p>Art. 9.3 Payment of the vehicle price;</p>
        <p>
            Art. 9.4 Advance invoicing upon Fleequid’s request, payment subject to the condition of full collection from the Buyer (pay-when-paid),
            obligation to issue a credit note in case of non-payment or cancellation of the sale, set-off rights, daily penalties for delays or
            omissions and Seller’s waiver of claims or objections against Fleequid;
        </p>
        <p>Art. 9.5 Penalty;</p>
        <p>Arts. 9.7 and 9.8 Time limits for notification of defects and non-conformities;</p>
        <p>Art. 9.10 Express termination clause and penalty;</p>
        <p>
            Art. 10 Payment terms, termination, penalties, conditions governing Resale and indemnity, mileage, time limits for defect inspection upon
            delivery;
        </p>
        <p>
            Art. 11 Exclusion of warranty and indemnity of Fleequid, transfer of risk, express termination clause, penalties, right to cancel the
            sale, sale, exclusion of latent defects, liability limits based on mileage and age of the vehicle;
        </p>
        <p>
            Art. 13 Complaints, proposed complaint resolutions, complaint resolution by Fleequid through cancellation of the sale, latent defects,
            indemnity, “as-is” clause, penalties;
        </p>

        <p>Art. 14 Connection clause;</p>
        <p>Art. 15 Applicable law, language and competent court.</p>
    </div>
</template>
